// extracted by mini-css-extract-plugin
export var bold = "_xv-0";